"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencySymbol = void 0;
const currencySymbol = (currency) => {
    let eurSymbol = "€";
    let usdSymbol = "$";
    let gbpSymbol = "£";
    if (currency === "EUR")
        return eurSymbol;
    else if (currency === "USD")
        return usdSymbol;
    else if (currency === "GBP")
        return gbpSymbol;
    return currency;
};
exports.currencySymbol = currencySymbol;
